export enum SidebarMenuItemType {
  HOME = 'home',
  MISSIONS = 'missions',
  PROFILE = 'profile',
  REWARD_SHOP = 'reward_shop',
  TOURNAMENTS = 'tournaments',
}
